// ? align with api schema
export enum FavoriteType {
  Apostle = 'Apostle',
  Godiverse = 'Godiverse',
  Planet = 'Planet',
  OrbitalTrack = 'OrbitalTrack',
  Star = 'Star'
}
